import React from "react";
import Select from "react-select";
import {Button,CardBody,Row,Col,InputGroup,Input,ListGroup,ListGroupItem} from "reactstrap";
import { ToastContainer } from "react-toastify";
import ImageUploadContainer from "../User/adding-user/ImageUploadContainer";
import type { PickedImage } from "../User/adding-user/ImageUploadContainer";

/** A react-select option as UpdateAdContainer builds it (label may be missing on a stale ref). */
type AdOption = { value: string; label?: string };

export type UpdateAdViewProps = {
  loading: boolean;
  ad: {
    adsTitle?: string;
    adsDescription?: string;
    adsLink?: string;
    // A stored URL, or the picker's object (a media-library pick carries secure_url).
    adsMedia?: string | { secure_url?: string };
    adsPosition?: string;
  };
  positions: AdOption[];
  positionValue: AdOption | null;
  clients: AdOption[];
  clientValue: AdOption | null;
  products: AdOption[];
  productValue: AdOption | null;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  onSelectPosition: (opt: AdOption | null) => void;
  onSelectClient: (opt: AdOption | null) => void;
  onSelectProduct: (opt: AdOption | null) => void;
  onClickUpdate: () => void;
  onImageUpload: (img: PickedImage) => void;
};

const UpdateAdView = ({
  loading,
  ad,
  positions,
  positionValue,
  clients,
  clientValue,
  products,
  productValue,
  onChange,
  onSelectPosition,
  onSelectClient,
  onSelectProduct,
  onClickUpdate,
  onImageUpload,
}: UpdateAdViewProps) => {
  const media = ad.adsMedia;
  const previewImage = media
    ? typeof media === "object" && media.secure_url
      ? media.secure_url
      : media
    : null;

  return (
    <>
      <div className="rna-wrapper"><ToastContainer /></div>

      <CardBody className="px-lg-2">
        <ListGroup className="list my--3" flush>
          <ListGroupItem className="px-0">
            <Row className="text-center">
              <Col>
                <ImageUploadContainer
                  ImageUpload={onImageUpload}
                  // Unchanged from the .jsx: a picked object without secure_url
                  // is passed through as it always was (SCRUM-2078 keeps behaviour).
                  image={previewImage as string | null}
                />
              </Col>
            </Row>
          </ListGroupItem>
          <ListGroupItem className="px-0">
            {/* Title */}
            <Row className="align-items-center">
              <div className="col ml-2 ">
                <h4 className="mb-2">
                  <a onClick={(e) => e.preventDefault()}>Title</a>
                </h4>
                <InputGroup className="mb-2">
                  <Input
                    placeholder="Title"
                    type="text"
                    name="adsTitle"
                    value={ad.adsTitle}
                    onChange={onChange}
                  />
                </InputGroup>
              </div>
            </Row>
            {/* Description */}
            <Row className="align-items-center">
              <div className="col ml-2 ">
                <h4 className="mb-2">
                  <a onClick={(e) => e.preventDefault()}>Description</a>
                </h4>
                <InputGroup className="mb-2">
                  <Input
                    placeholder="Description"
                    type="text"
                    name="adsDescription"
                    value={ad.adsDescription}
                    onChange={onChange}
                  />
                </InputGroup>
              </div>
            </Row>
            {/* Link */}
            <Row className="align-items-center">
              <div className="col ml-2 ">
                <h4 className="mb-2">
                  <a onClick={(e) => e.preventDefault()}>Link</a>
                </h4>
                <InputGroup className="mb-2">
                  <Input
                    placeholder="Link"
                    type="text"
                    name="adsLink"
                    value={ad.adsLink}
                    onChange={onChange}
                  />
                </InputGroup>
              </div>
            </Row>
            {/* Position */}
            <Row className="align-items-center">
              <div className="col ml-2 ">
                <h4 className="mb-2">
                  <a onClick={(e) => e.preventDefault()}>Position</a>
                </h4>
                <Select
                  value={positionValue}
                  options={positions}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  onChange={onSelectPosition}
                  isClearable
                  isSearchable
                />
              </div>
            </Row>
            {/* Related to (optional) */}
            <Row className="align-items-center">
              <div className="col ml-2 mt-2 ">
                <h4 className="mb-2">
                  <a onClick={(e) => e.preventDefault()}>Related to : (optional)</a>
                </h4>
              </div>
            </Row>
            {/* Client */}
            <Row className="align-items-center">
              <div className="col ml-2 mr-2 ">
                <h4 className="mb-2">
                  <a onClick={(e) => e.preventDefault()}>Client</a>
                </h4>
                <Select
                  value={clientValue}
                  options={clients}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  onChange={onSelectClient}
                  isClearable
                  isSearchable
                />
              </div>
            </Row>
            {/* Product */}
            <Row className="align-items-center">
              <div className="col ml-2 mr-2 ">
                <h4 className="mb-2">
                  <a onClick={(e) => e.preventDefault()}>Product</a>
                </h4>
                <Select
                  value={productValue}
                  options={products}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  onChange={onSelectProduct}
                  isClearable
                  isSearchable
                />
              </div>
            </Row>
            {/* Update */}
            <Row className="align-items-center">
              <div className="col ml-2 mr-2 mt-3 ">
                <Button
                  color="primary"
                  type="button"
                  onClick={onClickUpdate}
                  disabled={loading}
                >
                  {loading ? "Uploading..." : "Update"}
                </Button>
              </div>
            </Row>
          </ListGroupItem>
        </ListGroup>
      </CardBody>
    </>
  );
};

export default UpdateAdView;
